import Axios from 'axios';

export default {

  // 活动列表
  listPage(
    page,
    per_page
  ) {
    return Axios.get('/carouselmap/api/admin/lists', {
      params: {
        page,
        per_page
      }
    });
  },

  //改变显示状态
  changeEnable(
    id
  ) {
    return Axios.get('/carouselmap/api/admin/changeEnable', {
      params: {
        id
      }
    });
  },

  //添加轮播图
  add(
    title,
    banner,
    jump_way,
    link,
    model_type,
    model_id,
    model_title,
    community_ids,
    enable,
    type
  ) {
    return Axios.post('/carouselmap/api/admin/add', {
      title,
      banner,
      jump_way,
      link,
      model_type,
      model_id,
      model_title,
      community_ids,
      enable,
      type
    });
  },

  //编辑
  edit(
    id,
    title,
    banner,
    jump_way,
    link,
    model_type,
    model_id,
    model_title,
    community_ids,
    enable,
    type
  ) {
    return Axios.post('/carouselmap/api/admin/edit', {
      id,
      title,
      banner,
      jump_way,
      link,
      model_type,
      model_id,
      model_title,
      community_ids,
      enable,
      type
    });
  },

  //改变显示状态
  changeSort(
    id,
    operation
  ) {
    return Axios.get('/carouselmap/api/admin/changeSort', {
      params: {
        id,
        operation
      }
    });
  },

  //删除
  del(
    id
  ) {
    return Axios.delete('/carouselmap/api/admin/delete', {
      data: {
        id
      }
    });
  },

  //详情
  info(
    id
  ) {
    return Axios.get('/carouselmap/api/admin/info', {
      params: {
        id
      }
    });
  }

}